import FullPageLoader from '@/components/FullPageLoader';
import Sidebar from '@/components/Sidebar';
import SubscriptionExpiredOverlay from '@/components/subscription/SubscriptionExpiredOverlay';
import { useOrganizations } from '@/hooks/useOrganizations';
import { useSubscription } from '@/hooks/useSubscription';
import { FunctionComponent, PropsWithChildren, Suspense, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

interface iLayoutProps extends PropsWithChildren {}

const Layout: FunctionComponent<iLayoutProps> = ({ children }) => {
  // Populate the subscription atom on app boot so feature gates (and the
  // expired overlay) have data before the user lands on a subscription-aware
  // page. Without this, gates default to FREE until the user visits /subscription.
  useSubscription();
  const { organization } = useOrganizations();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (organization?.role !== 'BILLING_MANAGER') return;
    if (location.pathname === '/subscription') return;
    navigate('/subscription', { replace: true });
  }, [location.pathname, navigate, organization?.role]);

  return (
    <div className='flex h-screen'>
      <Sidebar />
      <div className='flex-1 flex flex-col overflow-x-hidden relative'>
        <SubscriptionExpiredOverlay />
        <Suspense fallback={<FullPageLoader />}>
          <Outlet />
        </Suspense>
        {children}
      </div>
    </div>
  );
};

export default Layout;
